import React from "react";
import { Video, Heart, HeartHandshake } from "lucide-react";
import { useSeo } from "@/hooks/useSeo";
import { useAuth } from "@/context/AuthContext";
import VideoIntroEditor from "@/components/VideoIntroEditor";

// -----------------------------------------------------------------------------
// VideoIntros — one page to manage Matrimonial + Dating video intros.
// -----------------------------------------------------------------------------
export default function VideoIntros() {
  const { user } = useAuth();
  useSeo({ title: "Video intros · Matrimonial & Dating · find2near",
           description: "Attach a short 30–60 s video to your matrimonial or dating profile — helps matches trust you're real.",
           canonical: "/video-intros" });

  if (!user) return (
    <div className="max-w-md mx-auto text-center py-24 px-6">
      <Video className="mx-auto text-fuchsia-500" size={44}/>
      <h2 className="heading text-2xl font-black mt-4">Sign in to manage video intros</h2>
      <p className="text-stone-500 mt-2 text-sm">Your videos are attached to your public matrimonial or dating profile.</p>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-4 md:px-6 py-6 space-y-4" data-testid="video-intros-page">
      <div>
        <div className="text-[11px] uppercase tracking-widest text-stone-500 font-bold flex items-center gap-2"><Video size={12} className="text-fuchsia-600"/> Video intros</div>
        <h1 className="heading text-3xl md:text-4xl font-black text-stone-900">Show up. <span className="text-fuchsia-700">In your own voice.</span></h1>
        <p className="text-stone-500 text-sm mt-1 max-w-xl">A 30–60 second video vastly improves trust and match rate. Paste any public URL — YouTube, Vimeo, or a direct MP4 upload.</p>
      </div>

      <div className="rounded-3xl bg-gradient-to-br from-rose-50 to-fuchsia-50 border border-rose-200 p-4 flex items-start gap-3">
        <HeartHandshake size={18} className="text-rose-600 mt-0.5"/>
        <div className="text-xs text-rose-900 leading-relaxed">
          <b>Tip:</b> Look directly at the camera. Speak for 30-45 seconds about your interests,
          family, and what you're looking for. Natural light. Skip loud music. Keep it kind.
        </div>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <VideoIntroEditor kind="matrimonial"/>
        <VideoIntroEditor kind="dating"/>
      </div>
    </div>
  );
}
